import React from "react";
import HTabsNavigation from "../../../hcomponents/HTabsNavigation";

const SettingsTabsNavigation = () => {
  const settingsTabs = [
    {
      label: "Profile",
      value: "Profile",
      route: "/host/settings",
    },
    // {
    //   label: "Branding",
    //   value: "Branding",
    //   route: "/host/branding-settings",
    // },
    // {
    //   label: "Notifications",
    //   value: "Notifications",
    //   route: "/host/settings-notifications",
    // },
    // {
    //   label: 'Roles & Permissions',
    //   value: 'Roles & Permissions',
    //   route: '/host/roles-settings',
    // },
    // {
    //   label: "API Settings",
    //   value: "API Settings",
    //   route: "/host/api-settings",
    // },
    {
      label: "Integrations",
      value: "Integrations",
      route: "/host/settings-integrations",
    },
    {
      label: "Payment Setup",
      value: "Payment Setup",
      route: "/host/settings-payment-setup",
    },
    {
      label: "Addons",
      value: "Addons",
      route: "/host/settings-addons",
    },
    // {
    //   label: "Building Addresses",
    //   value: "Building Addresses",
    //   route: "/host/settings-building-addresses",
    // },
  ];

  return <HTabsNavigation tabs={settingsTabs} defaultTab="Profile" />;
};

export default SettingsTabsNavigation;
